<template>
    <nav id="footer" class="footer-bar" :style="barStyle">
        <div class="footer-bar__cells">
            <template v-for="(cell, index) in footerMenu.main">
                <router-link
                    v-if="cell"
                    :key="index"
                    :to="cell.link"
                    class="footer-bar__cell"
                    :class="{ 'footer-bar__cell--active': isActive(cell) }"
                    :aria-current="isActive(cell) ? 'page' : null"
                >
                    <v-icon size="24" :color="isActive(cell) ? theme.footerIconSelectedColor : theme.footerIconColor">{{ cell.icon }}</v-icon>
                    <span class="footer-bar__label">{{ cell.title }}</span>
                </router-link>
                <span v-else :key="index" class="footer-bar__cell footer-bar__cell--empty" aria-hidden="true"></span>
            </template>
        </div>
    </nav>
</template>

<script>
import { layoutMixin } from '../../utils/layout-mixin';
import { eventMixin } from '../../utils/event-mixin';

// Bottom bar of the game: 2 or 4 equal cells from the main menu, an empty cell keeps its slot
export default {
    mixins: [layoutMixin, eventMixin],

    watch: {
        // Redirects from the plain tasks route to the first main menu entry. The watcher
        // keeps running on purpose: when entering an event it fires before the checkin has
        // finished, and only a later run delivers links with the real event id.
        footerMenu: {
            handler(menu) {
                const first = menu.main.find(Boolean);
                if(!first){
                    return;
                }
                // until the checkin of the routed event has finished, selectedEventId is unset
                // or stale and the links would point to /event/undefined/...
                if(!this.selectedEventId || String(this.selectedEventId) !== String(this.$route.params.id)){
                    return;
                }
                const pattern = /^\/event\/\d+\/tasks\/?$/;
                if(pattern.test(this.$route.path)){
                    this.$router.push(first.link);
                }
            },
            immediate: true
        }
    },

    computed: {
        barStyle() {
            return {
                'background-color': this.theme.headerFooterColor,
                '--footer-icon-color': this.theme.footerIconColor,
                '--footer-icon-selected-color': this.theme.footerIconSelectedColor,
            };
        },
    },
    methods: {
        isActive(cell) {
            return !!cell && this.$route.path === cell.link;
        },
    }
};
</script>

<style lang="scss" scoped>
/* positioned so the bar paints above the fixed map container of the task page */
.footer-bar {
    position: relative;
    flex: 0 0 auto;
    padding-bottom: env(safe-area-inset-bottom);
}
.footer-bar__cells {
    display: flex;
    height: 51px;
}
.footer-bar__cell {
    flex: 1 1 0;
    min-width: 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 2px;
    padding: 0 4px;
    color: var(--footer-icon-color);
    text-decoration: none;
    -webkit-tap-highlight-color: transparent;
}
.footer-bar__cell--active {
    color: var(--footer-icon-selected-color);
}
.footer-bar__cell--empty {
    pointer-events: none;
}
.footer-bar__label {
    max-width: 100%;
    font-size: 11px;
    line-height: 1.2;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
/* larger screens: cells capped and centered as a group */
@media (min-width: 960px) {
    .footer-bar__cells {
        justify-content: center;
    }
    .footer-bar__cell {
        max-width: 120px;
    }
}
</style>
